export const LANG= process.env.REACT_APP_LANG;

